import { SectionView } from './SectionView.ts';
import { ViewAnimationControllerAdapter } from './animation/ViewAnimationControllerAdapter.ts';
export class MovingSectionView extends SectionView {
    constructor(x, y, w, h, container, removePadding = true){
        super(x, y, w, h, container, removePadding);
        this.animationController = new ViewAnimationControllerAdapter(this);
    }
}
